import { configureStore } from '@reduxjs/toolkit';
import houseReducer from './houseSlice';

export const store = configureStore({
  reducer: { house: houseReducer },
});

// Temporary debug hook so room/opening state can be inspected from the
// browser console without needing the Redux DevTools extension.
window.__houseStore = store;
